import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from 'vuex-persistedstate'
import i18n, { defaultLocale } from '@/i18n'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    ownedModels: [] as string[],
    currentRegion: 'sv-SE',
    currentLocale: defaultLocale,
    shareName: ''
  },
  mutations: {
    setCurrentRegion (state, region) {
      state.currentRegion = region
    },
    setCurrentLocale (state, locale) {
      state.currentLocale = locale
    },
    setShareName (state, name) {
      state.shareName = name
    },
    setModelOwned (state, model) {
      const index = state.ownedModels.indexOf(model, 0)
      if (index === -1) {
        state.ownedModels.push(model)
      }
    },
    unsetModelOwned (state, model) {
      const index = state.ownedModels.indexOf(model, 0)
      if (index > -1) {
        state.ownedModels.splice(index, 1)
      }
    },
    toggleModelOwned (state, model) {
      const index = state.ownedModels.indexOf(model, 0)
      if (index === -1) {
        state.ownedModels.push(model)
      } else if (index > -1) {
        state.ownedModels.splice(index, 1)
      }
    }
  },
  actions: {
    changeLocale({ commit }, locale) {
      i18n.locale = locale
      commit('setCurrentLocale', locale)
    }
  },
  modules: {
  },
  plugins: [createPersistedState()]
})
